import { Link } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';

export function LearnHeader({ batchId, batchName }: { batchId: string; batchName: string }) {
  return (
    <div>
      <nav className="flex items-center gap-1.5 text-sm font-medium text-[#9ca3af]" aria-label="Breadcrumb">
        <Link to="/courses" className="transition-colors hover:text-[#ff5a1f]">My Batches</Link>
        <ChevronRight className="size-3.5" />
        <Link to="/courses/$batchId" params={{ batchId }} className="transition-colors hover:text-[#ff5a1f]">{batchName}</Link>
        <ChevronRight className="size-3.5" />
        <span className="font-semibold text-[#ff5a1f]">Learn</span>
      </nav>
      <h1 className="pt-4 text-[34px] font-bold leading-[1.05] text-[#111827] sm:text-[52px] sm:leading-[52px]">Learn</h1>
      <p className="pt-1 text-base font-medium text-[#6b7280] sm:text-[18px] sm:leading-[27px]">
        Explore modules and continue your learning journey.
      </p>
    </div>
  );
}
